import { createSlice } from "@reduxjs/toolkit"
import { status_slices } from "../../Constants";



export const evidences = createSlice({
    name: 'evidences',
    initialState: {
        isLoading: true,
        evidencesItems: [],
        status: status_slices.SUCCESS,
    },
    reducers: {
        clearEvidences: (state, action) => {
            state.isLoading = false;
            state.evidencesItems = [];
        },
        setEvidences: (state, action) => {
            state.isLoading = false;
            state.evidencesItems = action.payload.items;
            state.status = status_slices.LOADED;
        },
        // Reducers Estaticos
        processRequest: (state, action) => {
            state.isLoading = true;
            state.status = status_slices.PROCESSING;
        },
        notProcessRequest: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.WAITING;
        },
         setError: (state, action) => {
            state.isLoading = false;
            state.status = status_slices.NOT_LOADED;
        },
    }
});

export const { processRequest, notProcessRequest, clearEvidences, setEvidences,setError } = evidences.actions;